import { useQuery } from 'react-query'
import { getRegistrations } from 'services/registrations'
import { UserDetail } from 'types'

const TRAINER_LEVELS = ['OL1', 'L1', 'L2', 'L3', 'L4']

export function useRegistrations(userId: number) {
  const response = useQuery(
    ['registrations', userId],
    () => getRegistrations(userId),
    { enabled: !!userId },
  )

  return {
    registrations: response.data,
  }
}

export function useIsRegisteredForTrainingCourse(user?: UserDetail) {
  const registrations = useRegistrations(user?.userId)?.registrations ?? []
  const userTrainerRegistrations = registrations?.filter(
    (r) =>
      TRAINER_LEVELS.some((tl) => r?.course?.skuCode?.includes(tl)) &&
      new Date(r?.expiration) > new Date(),
  )
  const userTrainerCerts = user?.certifications?.filter(
    (c) =>
      TRAINER_LEVELS.includes(c?.level) && new Date(c?.expiration) > new Date(),
  )

  if (!user?.userId) {
    return undefined
  }

  if (!userTrainerCerts?.length) {
    return false
  }

  if (!userTrainerRegistrations?.length) {
    return false
  }

  const userLevels =
    userTrainerCerts
      ?.map((c) => c?.level)
      .sort()
      .reverse()
      .filter((l) => TRAINER_LEVELS.includes(l)) ?? []

  const highestTrainerLevel =
    userLevels[0] === 'OL1'
      ? userLevels?.length > 1
        ? userLevels[1]
        : 'OL1'
      : userLevels[0]

  const trainerRegistrationSkus = userTrainerRegistrations
    ?.map((tr) => tr?.course?.skuCode)

    .map((s) => {
      const sku = s.split('-')

      return sku[sku.length - 1]
    })
    .sort()
    .reverse()

  const highestTrainerRegistrationLevel =
    trainerRegistrationSkus[0] === 'OL1'
      ? trainerRegistrationSkus?.length > 1
        ? trainerRegistrationSkus[1]
        : 'OL1'
      : trainerRegistrationSkus[0]

  const highestTrainerRegistrationLevelIndex = TRAINER_LEVELS.findIndex(
    (tl) => tl === highestTrainerRegistrationLevel,
  )
  const highestTrainerLevelIndex = TRAINER_LEVELS.findIndex(
    (tl) => tl === highestTrainerLevel,
  )

  if (
    highestTrainerRegistrationLevelIndex <= 1 &&
    highestTrainerLevelIndex <= 1
  ) {
    return true
  }

  if (highestTrainerRegistrationLevelIndex >= highestTrainerLevelIndex) {
    return true
  }

  return false
}
